// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement("img")
  overlayImage.setAttribute("src", `${image.src}`)
  const overlay = document.createElement("div")
  prepareOverlay(overlay, overlayImage)

  image.style.opacity = "50%"

  overlayImage.onload = () => {
    image.parentElement.insertBefore(overlay, image)
    image.style.opacity = "100%"
  }

  return overlay
}

function prepareOverlay(container, image) {
  container.setAttribute("class", "image-magnify-full-size")
  container.setAttribute("aria-hidden", "true")
  container.style.backgroundImage = `url('${image.src}')`
  container.style.backgroundColor = "var(--gradient-background)"
  container.style.position = "absolute"
  container.style.top = "0"
  container.style.left = "0"
  container.style.width = "100%"
  container.style.height = "100%"
  container.style.cursor = "zoom-out"
  container.style.zIndex = "1000"
}

function moveWithHover(image, event, zoomRatio, overlay) {
  // calculate mouse position
  const ratio = image.height / image.width
  const container = event.target.getBoundingClientRect()
  const xPosition = event.clientX - container.left
  const yPosition = event.clientY - container.top
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image)
  overlay.onclick = () => overlay.remove()
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, overlay)
  overlay.onmouseleave = () => overlay.remove()
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll(".product__media img, .image-magnify-hover")
  images.forEach((image) => {
    if (image.complete) {
      setupImageZoom(image, zoomRatio)
    } else {
      image.onload = () => setupImageZoom(image, zoomRatio)
    }
  })
}

function setupImageZoom(image, zoomRatio) {
  image.style.cursor = "zoom-in"
  image.onclick = (event) => {
    event.preventDefault()
    magnify(image, zoomRatio)
    const overlay = image.parentElement.querySelector(".image-magnify-full-size")
    if (overlay) {
      moveWithHover(image, event, zoomRatio, overlay)
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  enableZoomOnHover(2)
})

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    enableZoomOnHover(2)
  })
} else {
  enableZoomOnHover(2)
}
